import React from "react";
import { AYLAR } from "@/lib/api";

export const primPeriod = (r) => r?.prim_ayi || (r?.tarih || "").slice(0, 7);
export const isMonthShifted = (r) => !!r?.prim_ayi && r.prim_ayi !== (r.tarih || "").slice(0, 7);

export function ShiftedMonthToggle({ active, count, onToggle }) {
  return (
    <button type="button" data-testid="prim-filter-month-shifted" onClick={onToggle}
      title="Yalnızca Prim Ayı, tarihin ayından farklı olan primler"
      className={`inline-flex items-center gap-1.5 px-2.5 py-1.5 rounded-md text-xs font-semibold border transition-colors ${
        active ? "bg-indigo-600 text-white border-indigo-700 hover:bg-indigo-700" : "bg-white text-indigo-700 border-indigo-300 hover:bg-indigo-50"}`}>
      Ayı farklı olanlar
      <span data-testid="prim-filter-month-shifted-count"
        className={`min-w-[18px] h-[18px] px-1 rounded-full text-[10px] font-bold inline-flex items-center justify-center ${active ? "bg-white text-indigo-700" : "bg-indigo-600 text-white"}`}>{count}</span>
    </button>
  );
}

export function PrimMonthBadge({ r }) {
  if (!isMonthShifted(r)) return null;
  const [y, m] = r.prim_ayi.split("-");
  const ad = AYLAR.find((a) => a.v === Number(m))?.n || m;
  return (
    <span data-testid={`prim-month-badge-${r.id}`} title="Primin ait olduğu ay"
      className="ml-1 inline-block text-[10px] font-bold bg-indigo-50 text-indigo-700 border border-indigo-200 rounded px-1.5 py-0.5 align-middle">
      → {ad} {y}
    </span>
  );
}

export function PrimMonthPicker({ value, onChange }) {
  const [y, m] = (value || "").split("-").map(Number);
  const nowY = new Date().getFullYear();
  const years = Array.from(new Set([nowY - 1, nowY, nowY + 1, y].filter(Boolean))).sort();
  const set = (ny, nm) => onChange(`${ny}-${String(nm).padStart(2, "0")}`);
  const cls = "border border-slate-300 rounded-lg px-2 py-2.5 text-sm bg-white focus:outline-none focus:ring-2 focus:ring-slate-900";
  return (
    <div className="flex gap-2">
      <select data-testid="prim-ayi-month" value={m || ""} onChange={(e) => set(y || nowY, e.target.value)} className={`${cls} flex-1`}>
        {AYLAR.map((a) => <option key={a.v} value={a.v}>{a.n}</option>)}
      </select>
      <select data-testid="prim-ayi-year" value={y || ""} onChange={(e) => set(e.target.value, m || 1)} className={cls}>
        {years.map((yy) => <option key={yy} value={yy}>{yy}</option>)}
      </select>
    </div>
  );
}
